import axios from "@/plugins/axios";
const local = false;
/**
 * Conecta con el socket para avisar que el perfil a recibido actualizaciones.
 *
 * @return {Bolean} Lista de Empresas con sus campañas.
 */
export async function deleteUserSocket(data) {
  const url = local
    ? "http://localhost:8081/users/send-delete-user"
    : `${import.meta.env.VITE_SOCKET}users/send-delete-user`;
  const response = await axios.post(url, {
    customer_id: data.customer_id,
    iduser: data.user_id,
    title: data.title,
    description: data.description,
  });

  return response.data;
}
